import { bodiedSyncBlockStage0 } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * Represents a block node that is designed to be synchronized
 * with an external resource across different products.
 * @name bodiedSyncBlock_node
 */

export var bodiedSyncBlock = bodiedSyncBlockStage0({
  parseDOM: [{
    tag: 'div[data-bodied-sync-block]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      var attrs = {
        localId: dom.getAttribute('data-local-id') || uuid.generate(),
        resourceId: dom.getAttribute('data-resource-id') || ''
      };
      return attrs;
    }
  }],
  toDOM: function toDOM(node) {
    var _node$attrs = node.attrs,
      localId = _node$attrs.localId,
      resourceId = _node$attrs.resourceId;
    var name = 'div';
    var attrs = {
      'data-bodied-sync-block': '',
      'data-local-id': localId,
      'data-resource-id': resourceId
    };
    return [name, attrs, 0];
  }
});